module.exports = "<section class=\"modal__social-slider js-modal\"> <div class=\"modal__background js-close\"></div> <div class=\"modal__content modal__content--stockists\"> <button class=\"modal__button--close cta js-close\">close</button> <div class=\"stockists js-store-picker\"> </div> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./templates/modals/stockists/modal.html
// module id = 63
// module chunks = 0